export enum QueryKeys {
  RegistryAddress = "registryAddress",
  SidechainGaugeWeightData = "sidechainGaugeWeightData",
}
